import { minutesToTimeString, timeStringToMinutes } from "./time-string.utils";
import type { DayTemplate, TimeSlotOption } from "./training-schedule-form.types";

// Time boundaries
export const MORNING_START_MIN = "06:00";
export const MORNING_START_MAX = "11:30"; // Prevent creating "morning" slots that start at noon
export const MORNING_END_MAX = "13:30";
export const AFTERNOON_START_MIN = "12:00";
export const AFTERNOON_END_MAX = "21:00";

// Default times when selecting a new date (Paris time)
export const DEFAULT_MORNING_START = "08:00";
export const DEFAULT_MORNING_END = "12:00";
export const DEFAULT_AFTERNOON_START = "13:00";
export const DEFAULT_AFTERNOON_END = "17:00";

/**
 * Half-days a date starts with, and the initial state of the "journée type" panel.
 * Single source so the panel always mirrors a freshly selected date.
 */
export const DEFAULT_DAY_TEMPLATE: DayTemplate = {
  morning: { enabled: false, start: DEFAULT_MORNING_START, end: DEFAULT_MORNING_END },
  afternoon: { enabled: true, start: DEFAULT_AFTERNOON_START, end: DEFAULT_AFTERNOON_END },
};

/**
 * Single source for the half-day rules messages, shared by the validation schema
 * and the "journée type" panel so both always report a rule the same way.
 */
export const HALF_DAY_SCHEDULE_ERRORS = {
  noHalfDayEnabled: "Veuillez sélectionner au moins un créneau (matin ou après-midi)",
  overlap: "Les créneaux matin et après-midi ne doivent pas se chevaucher",
} as const;

// Time slot granularity in minutes
export const TIME_SLOT_GRANULARITY = 30;

/**
 * Generate time slots with 30-minute granularity, both bounds included
 */
const generateTimeSlots = (startTime: string, endTime: string): TimeSlotOption[] => {
  const slots: TimeSlotOption[] = [];
  const endMinutes = timeStringToMinutes(endTime);

  for (let minutes = timeStringToMinutes(startTime); minutes <= endMinutes; minutes += TIME_SLOT_GRANULARITY) {
    const timeString = minutesToTimeString(minutes);
    slots.push({ label: timeString, value: timeString });
  }

  return slots;
};

// Generate morning start time slots (06:00 - 11:30) - limited to prevent "morning" starting at noon
export const MORNING_START_TIME_SLOTS: TimeSlotOption[] = generateTimeSlots(MORNING_START_MIN, MORNING_START_MAX);

// Generate morning end time slots (06:00 - 13:30)
export const MORNING_END_TIME_SLOTS: TimeSlotOption[] = generateTimeSlots(MORNING_START_MIN, MORNING_END_MAX);

// Generate afternoon time slots (12:00 - 21:00)
export const AFTERNOON_TIME_SLOTS: TimeSlotOption[] = generateTimeSlots(AFTERNOON_START_MIN, AFTERNOON_END_MAX);
